import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-6" }
const _hoisted_2 = { class: "card-body pt-5 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Cấu hình website")
], -1)
const _hoisted_5 = { class: "me-0 mb-0 text-end" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_8 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Chung ")
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Trang chủ ")
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Đại lý ")
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Menu ")
const _hoisted_17 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_18 = { class: "card-body pt-10" }
const _hoisted_19 = { class: "tab-content" }
const _hoisted_20 = {
  class: "tab-pane fade active show",
  id: "tabs_edit_general",
  item: "tabpanel"
}
const _hoisted_21 = { class: "my-5 px-8" }
const _hoisted_22 = { class: "row g-9 mb-8" }
const _hoisted_23 = { class: "col-md-7 fv-row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h3", null, "Từ khóa seo", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Robots", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", null, "Tiêu đề seo", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h3", null, "Nội dung seo", -1)
const _hoisted_28 = { class: "col-md-5 fv-row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", null, "Ảnh Thumbnail share", -1)
const _hoisted_30 = { class: "d-flex justify-content-between" }
const _hoisted_31 = { class: "svg-icon svg-icon-2" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-12 mb-5" }
const _hoisted_36 = { class: "d-flex justify-content-between" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-2 mb-2" }, "Ảnh Sliders trang chủ", -1)
const _hoisted_38 = { class: "svg-icon svg-icon-2" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "image-input image-galleries p-4 image-input-outline m-2 w-100" }
const _hoisted_42 = {
  class: "image-input-wrapper h-150px w-100",
  style: `width:299px;`
}
const _hoisted_43 = ["src"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-3 text-white" }, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "my-5 px-8" }
const _hoisted_48 = { class: "d-flex mb-5 justify-content-between" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-2 mb-2" }, "Slider Ảnh Videos giữa trang", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle fs-4" }),
  /*#__PURE__*/_createTextVNode(" Thêm nội dung ")
], -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "position-relative border p-4" }
const _hoisted_54 = { class: "d-flex justify-content-between" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "svg-icon svg-icon-2" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_58 = ["src"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-4" }, null, -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "tabs_edit_seo",
  item: "tabpanel"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column px-9" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row g-9 mb-8" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    id: "add_experience_form",
    model: _ctx.objectData,
    rules: _ctx.rules,
    ref: "formRef",
    class: "form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn-primary btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit())),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loading ? "Đang xử lý..." : "Lưu lại"), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_router_link, {
                  to: { name: 'general_configs' },
                  class: "nav-link text-active-primary me-6"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: { name: 'home_configs' },
                  class: "nav-link text-active-primary me-6 active"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_13, [
                _createVNode(_component_router_link, {
                  to: { name: 'configs_agency' },
                  class: "nav-link text-active-primary me-6"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createVNode(_component_router_link, {
                  to: { name: 'configs_menu' },
                  class: "nav-link text-active-primary me-6"
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_el_form_item, { prop: "seo.keywords" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.seo.keywords,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.objectData.seo.keywords) = $event)),
                          name: "keyword"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_25,
                    _createVNode(_component_el_form_item, { prop: "robot" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.objectData.seo.robot,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objectData.seo.robot) = $event)),
                          placeholder: "",
                          name: "robot"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "index, follow",
                              value: "index, follow"
                            }),
                            _createVNode(_component_el_option, {
                              label: "index, nofollow",
                              value: "index, nofollow"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_26,
                    _createVNode(_component_el_form_item, { prop: "seo.title" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.seo.title,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objectData.seo.title) = $event)),
                          placeholder: "",
                          name: "seo_title"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_27,
                    _createVNode(_component_el_form_item, { prop: "seo.description" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.seo.description,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.objectData.seo.description) = $event)),
                          placeholder: "",
                          name: "seo_des",
                          rows: "4",
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showSingleMedia('seo.thumbnail'))),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, [
                        _createElementVNode("span", _hoisted_31, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                          _hoisted_32
                        ])
                      ])
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "image",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          style: {"width":"100%"},
                          src: _ctx.renderImageUrl(_ctx.objectData.seo.thumbnail, 'medium'),
                          alt: ""
                        }, null, 8, _hoisted_33)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showMultipleMedia('banners_top'))),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, [
                        _createElementVNode("span", _hoisted_38, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                          _hoisted_39
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectData.banners_top, (img, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "col-md-6"
                        }, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("img", {
                                class: "w-100",
                                style: {"object-fit":"cover","height":"150px"},
                                src: _ctx.renderImageUrl(img, 'medium'),
                                alt: ""
                              }, null, 8, _hoisted_43)
                            ]),
                            _createElementVNode("label", {
                              class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-danger shadow",
                              "data-kt-image-input-action": "change",
                              "data-bs-toggle": "tooltip",
                              onClick: ($event: any) => (
                              _ctx.removeImages({
                                name: 'banners_top',
                                index: index,
                              })
                            )
                            }, _hoisted_46, 8, _hoisted_44)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addContent())),
                    class: "btn btn-primary btn-sm end",
                    "data-kt-menu-trigger": "click",
                    "data-kt-menu-placement": "bottom-end",
                    "data-kt-menu-flip": "top-end"
                  }, _hoisted_51)
                ]),
                _createElementVNode("div", _hoisted_52, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectData.banners_middle, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "col-md-6 mb-5"
                    }, [
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_el_form_item, { class: "my-3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.objectData.banners_middle[index].url_youtube,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.objectData.banners_middle[index].url_youtube) = $event),
                              placeholder: "Link youtube video",
                              name: "name"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (
                            _ctx.showSingleMedia(
                              'banners_middle.' + index + '.image'
                            )
                          ),
                            class: "btn btn-primary btn-sm end",
                            "data-kt-menu-trigger": "click",
                            "data-kt-menu-placement": "bottom-end",
                            "data-kt-menu-flip": "top-end"
                          }, [
                            _createElementVNode("span", _hoisted_56, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                              _hoisted_57
                            ])
                          ], 8, _hoisted_55)
                        ]),
                        _createVNode(_component_el_form_item, {
                          prop: "image",
                          class: "mt-4"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              style: {"width":"100%"},
                              src: 
                            _ctx.renderImageUrl(
                              _ctx.objectData.banners_middle[index].image,
                              'medium'
                            )
                          ,
                              alt: ""
                            }, null, 8, _hoisted_58)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("button", {
                          style: {"right":"-10px","top":"-10px"},
                          class: "btn btn-sm btn-danger position-absolute right-0 btn-circle btn btn-icon",
                          type: "button",
                          onClick: ($event: any) => (_ctx.removeContent(index))
                        }, _hoisted_61, 8, _hoisted_59)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _hoisted_62
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}